import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


import { AuthenticationGuard } from '../authentication/authentication.guard';
import { CodeEnforcementRoutingModule } from './code-enforcement.routing.module';
import { CodeEnforcementService } from './code-enforcement.service';
import { CodeEnforcementComponent } from './code-enforcement.component';
import { AddressSearchComponent } from './case-search/case-search.component';

import { ExpiredCaseComponent } from './expired-case/expired-case.component';
import { CodeEnforcementSigninFormComponent } from './code-enforcement-signin-form/code-enforcement-signin-form.component';
import { CreateCaseComponent } from './case/create-case/create-case.component';
import { CaseListingComponent } from './case/case-listing/case-listing.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CodeEnforcementRoutingModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatTabsModule,
        MatDialogModule,
        SharedModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatStepperModule,
        MatAutocompleteModule
    ],
    providers: [CodeEnforcementService, AuthenticationGuard],
    exports: [MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatAutocompleteModule],
    declarations: [CodeEnforcementComponent, AddressSearchComponent, CreateCaseComponent, ExpiredCaseComponent, CodeEnforcementSigninFormComponent, CaseListingComponent]
})
export class CodeEnforcementModule { }
